module.exports = __webpack_public_path__ + "img/cl-install-DEM-001-connection_12200.1a54e680.png";